import { render, staticRenderFns } from "./SelectUserDialog.vue?vue&type=template&id=66315335&scoped=true&"
import script from "./SelectUserDialog.vue?vue&type=script&lang=js&"
export * from "./SelectUserDialog.vue?vue&type=script&lang=js&"
import style0 from "./SelectUserDialog.vue?vue&type=style&index=0&id=66315335&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66315335",
  null
  
)

export default component.exports